import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";
import store from "../store/index";

Vue.use(VueRouter);

const routes = [{
    path: "/:id",
    name: "home",
    component: HomeView,
  },

  {
    path: "/HomeView/:id",
    name: "HomeView",
    component: HomeView,
  },
  {
    path: "/course/:id",
    name: "CrouseView",
    component: () => import("@/views/CrouseView.vue"),
  },
  {
    path: "/courseplay/:id",
    name: "courseplay",
    component: () => import("@/views/courseplay.vue"),
  },
  {
    path: "/Crousemine/:id",
    name: "Crousemine",
    component: () => import("@/views/Crousemine.vue"),
  },
  {
    path: "/examination/:id",
    name: "examination",
    component: () => import("@/views/examination/startExam.vue"),
  },
  {
    path: "/netschool/:id",
    name: "school",
    alias: "/newpageschool/:id",
    component: () => import("@/views/school/school.vue"),
    redirect: (to) => {
      // var alink = window.location.href;
      // if (alink.indexOf("/newpageschool/") == -1) {
      //   localStorage.setItem("schoolId", to.params.id);
      // }
      // return "/netschool/schoolHome/" + localStorage.getItem("schoolId");
      return "/netschool/schoolHome/" + to.params.id;
    },
    children: [{
        path: "/netschool/schoolHome/:id",
        name: "schoolHome",
        component: () => import("@/views/school/schoolHome.vue"),
      },
      {
        path: "/netschool/schoolStudy/:id",
        name: "schoolStudy",
        component: () => import("@/views/school/schoolStudy.vue"),
      },
      {
        path: "/netschool/schoolMsg/:id",
        name: "schoolMsg",
        component: () => import("@/views/school/schoolMsg.vue"),
      },
      {
        path: "/netschool/schoolMine/:id",
        name: "schoolMine",
        component: () => import("@/views/school/schoolMine.vue"),
      },
      {
        path: "/netschool/schoolMore/:id",
        name: "schoolMore",
        component: () => import("@/views/school/schoolMore.vue"),
      },
    ],
  },
  {
    path: "/goods/:id",
    name: "GoodsView",
    component: () => import("@/views/GoodsView.vue"),
  },
  {
    path: "/linkExpire/404",
    name: "LinkExpire",
    component: () => import("@/views/LinkExpire.vue"),
  },
];

const router = new VueRouter({
  mode: "hash",
  routes,
});

router.beforeEach((to, from, next) => {
  store.commit("setCurrentPage", to.name);
  next();
});

export default router;